var map = {
	"./(jiu)视频会议.png": 7698,
	"./SD-WAN.jpg": 446,
	"./SDDC.jpg": 1260,
	"./SDN.png": 6545,
	"./办公自动化.png": 8262,
	"./应用性能管理.png": 1335,
	"./智能运维管理.jpg": 5532,
	"./模块化数字机房.png": 7256,
	"./能耗管理.png": 1679,
	"./虚拟化.png": 3177,
	"./视频会议.png": 1789,
	"./超融合.png": 6534,
	"./（jiu）模块化数字机房.png": 5901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5372;